import { isFunction } from 'lodash/fp';
import { getHybridUseCase } from '../../hybridApp/hybridAppUtils';
import { HybridUseCase } from '../../hybridApp/hybridAppConstants';

const shouldGetHybridOnboardingSteps = () => {
    switch (getHybridUseCase()) {
        case HybridUseCase.ANDROID_BOARD_LIST:
        case HybridUseCase.IOS_CANVAS:
        case HybridUseCase.IOS_BOARD_LIST:
            return true;
        case HybridUseCase.IPAD_OS:
        default:
            return false;
    }
};

let getOnboardingStep;
if (process.env.BROWSER) {
    if (shouldGetHybridOnboardingSteps()) {
        getOnboardingStep = require('./config/getOnboardingStepHybrid').default;
    } else {
        getOnboardingStep = require('./config/getOnboardingStep').default;
    }
} else {
    getOnboardingStep = require('./config/getOnboardingStepElectron').default;
}

const hasFunctionSelector = (step) => isFunction(step.getIn(['tip', 'selector']));

export const selectStep = (stepId, action, state) => {
    let step = getOnboardingStep(stepId);

    if (step && hasFunctionSelector(step)) {
        step = step.setIn(['tip', 'selector'], step.getIn(['tip', 'selector'])(action, state));
    }

    return step;
};

export const getNextStepBasedOnAction = (next, action, state) => {
    if (!next) return;

    const nextTo = next(action, state);

    return nextTo && selectStep(nextTo, action, state);
};
